tet<template>
  <div class="store" id="test">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      labelWidth="125px"
      :defaultRow="2"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @changeSupplyChainMethod="changeSupplyChainMethod"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
      @changeProject="changeProject"
      @changePerson="changePerson"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :showFooter="true"
        :footerMethod="footerMethod"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'expenseType'">{{
              expenseType?.find((item) => item.value == row['expenseType'])?.label
            }}</template>
            <template v-else-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <!-- <template v-else-if="item.field === 'statementQuantity'">{{
              row.statementQuantity | formateQuantityToWumao(isWuMaoAccount)
            }}</template> -->
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else-if="['originalPrice', 'statementQuantity'].includes(item.field)">{{
              replaceLastZeroStr(row[item.field])
            }}</template>
            <template v-else-if="['originalAmount', 'domesticAmount'].includes(item.field)">{{
              $utils.commafy($utils.toNumber(replaceZeroStr(row[item.field])), { digits: 2 })
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import API from '@/api/storeMasterData';
  import { searchColumns, defaultTableColumn } from './index.js';
  // import tradeMixin from './../../mixin/tradeMixin';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import expenseListMixin from './index.js';
  export default {
    mixins: [expenseListMixin],
    name: 'Trade',
    components: {
      SiruiSearch,
      SiruiTable,
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      expenseType() {
        return this.dictListMap.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
      // console.log(JSON.parse(localStorage.getItem('userInfo')).userInfo.oaId, '费用清单');
      this.query = {
        ...this.query,
        ...{
          personIds: [this.userInfo.userCode],
          personNames: this.userInfo.userName,
        },
      };
      if (this.$route.query?.contractNo) {
        this.query.contractNo = this.$route.query?.contractNo;
        this.query.processStatus = this.$route.query?.processStatus.toString();
      }
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: [],
        query: {
          pageNum: 1,
          pageSize: 10,
          businessCompanyNo: '',
          businessDepartmentCode: '',
          processStatus: null,
          expenseType: '',
          businessCategory: '01',
          accountPeriod: '',
          periodDateStart: '',
          periodDateEnd: '',
          customerNo: '',
          vehicleNo: '',
          projectInitiationNoLike: '',
          projectNameLike: '',
          baseNameLike: '',
          expenseNoLike: '',
          businessDateStart: '',
          businessDateEnd: '',
          contractNo: '',
          delivererNo: '',
          createMethod: '',
          settlementNo: '',
          originalAmountStart: '',
          originalAmountEnd: '',
          salesmanNo: '',
          personIds: [],
          personNames: '',
        },
        companyCode: null,
        tableTotal: 15,
      };
    },
    methods: {
      changePerson({ val, prop }) {
        console.log(val, prop, '=1111=');
        if (prop == 'personNames') {
          const rowData = val && Array.isArray(val) && val.length ? val : [];
          this.query.personNames = rowData.map((item) => item.personName).join(',');
          this.query.personIds = rowData.map((item) => item.id).filter((item) => Boolean(item));
        }
      },
      changeProject({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'projectNameLike') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectNameLike = rowData.projectAbbreviation || rowData.projectName || '';
          this.query.projectInitiationNoLike = rowData.projectInitiationNo || '';
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.replaceZeroStr(
                data.reduce((cur, next) => cur + +next.originalAmount, 0).toFixed(2)
              );
            } else if (['domesticAmount'].includes(column.property)) {
              return this.replaceZeroStr(
                data.reduce((cur, next) => cur + +next.domesticAmount, 0).toFixed(2)
              );
            } else if (['statementQuantity'].includes(column.property)) {
              return this.replaceZeroStr(
                data
                  .reduce((cur, next) => cur + +next.statementQuantity, 0)
                  .toFixed(this.isWuMaoAccount ? 8 : 2)
              );
            }
            return null;
          }),
        ];
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log(selection);
        const originalAmount = selection.reduce((prev, cur) => prev + +cur.originalAmount, 0);
        const domesticAmount = selection.reduce((prev, cur) => prev + +cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(originalAmount).toFixed(2),
          this.$globalVar.qPoint
        );
        totalDom2.querySelector('.vxe-cell').innerHTML = this.$utils.commafy(
          this.$utils.toNumber(domesticAmount).toFixed(2),
          this.$globalVar.qPoint
        );
        // totalDom1.querySelector('.vxe-cell').innerHTML = originalAmount.toFixed(2);
        // totalDom2.querySelector('.vxe-cell').innerHTML = domesticAmount.toFixed(2);
      },

      // // 切换公司
      // changeCompanyHandler(val, partnerZhName1) {
      //   console.log(val, '切换公司', partnerZhName1);
      //   this.companyCode = val.val;
      //   this.query.businessDepartmentCode = null;
      // },
      // 切换供应商
      changeSupplyChainMethod(val) {
        console.log(val, '修改客户');
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerNo: rowData?.partnerCode,
        };
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 修改投送人
      changeDelivererNameMethod(val) {
        console.log(val, '修改同送人');
        this.query.delivererNo = val[0]?.personNo || '';
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.personNo || '';
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '应收查看按钮列表');
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn;
        });
      },
      // 获取表格数据
      async getTableData(search) {
        console.log(search, '搜索');
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLESEXPENSE_QUERY,
          postData
        );
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data.records;
        this.tableData.forEach((item) => {
          item.domesticAmount = item.domesticAmount.toFixed(2);
          item.originalAmount = item.originalAmount.toFixed(2);
        });
        this.$refs.siruiTable.setPageTotal(data.data.total);
      },
      // 表格上面的按钮
      async chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          const selectedList = this.multipleSelection;
          if (!selectedList.length) {
            this.$message.error('请选择行操作');
            return;
          }
          let processStatusList = selectedList.filter((item) => item.processStatus == 1);
          console.log(processStatusList, 'processStatusList');
          if (processStatusList.length > 0) {
            this.$message.error('已处理的费用清单不能再次创建');
            return;
          }
          let productNameList = [];
          let productNameStatus = null;
          let contractNoList = [];
          let contractNoStatus = null;
          let ids = [];
          selectedList.map((item) => {
            productNameList.push(item.productName);
            contractNoList.push(item.contractNo);
            ids.push(+item.id);
          });
          console.log(ids, 'idssssssssssss');
          productNameStatus = this.isAllEqual(productNameList);
          contractNoStatus = this.isAllEqual(contractNoList);
          // console.log(productNameList, 'productNameList');
          // console.log(productNameStatus, 'productNameStatus');
          // console.log(contractNoList, 'contractNoList');
          // console.log(contractNoStatus, 'contractNoStatus');

          if (!productNameStatus || !contractNoStatus) {
            this.$message.error('所选合同和商品名称不一致');
            return;
          }

          let path = {
            path: '/receivablesAndPayables/tradeReceivablesDetail',
            name: 'tradeReceivablesDetail',
            meta: {
              keepAlive: true,
              title: '贸易应收结算单',
            },
            query: {
              status: 'create',
              id: ids,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'export') {
          const selectedList = this.multipleSelection;
          if (selectedList.length > 0) {
            const postData = [];
            selectedList.map((item) => {
              postData.push(item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT, {
              ids: postData,
              businessCategory: this.query?.businessCategory,
            });
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error(`${data.msg}`);
            }
          } else {
            const postData = this.query;
            const { data } = await this.$axios.post(
              RECEIVABLES_TRADE.RECEIVABLESEXPENSE_EXPORT,
              postData
            );
            if (data.code === 0) {
              window.location.href = data.data;
              this.$message.success('导出成功');
            } else {
              this.$message.error(`${data.msg}`);
            }
          }
        }
      },
      //判断数组里元素是否全相等
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },

      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._computedAmount([]);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.query.projectNameLike = '';
        this.query.projectInitiationNoLike = '';
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.query = {
          ...this.query,
          // businessCompanyNo: this.userInfo.companyCode,
          // businessDepartmentCode: this.userInfo?.departmentCode,
        };
        this._computedAmount([]);
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    watch: {
      $route(val) {
        if (val.query?.contractNo) {
          this.query.contractNo = val.query?.contractNo;
          this.query.processStatus = val.query?.processStatus.toString();
          this.getTableData();
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
